import blankAction from '../assets/images/bbBlankAction.png'
import getAction from './getAction'

export default function getCombatantLastRoundAction(combatant, maxCA) {

  console.log('----------------------------------------------------------------------------------')
  console.log('IN getCombatantLastRoundAction combatant = ', combatant.name, ' maxCA = ', maxCA)

  console.log('combatant snapshot = ', JSON.parse(JSON.stringify(combatant)))

  // loop through combatant's actions in reverse order to find the last valid action
  for (let actionNum = maxCA; actionNum >= 1; actionNum--) {

    const imageField = 'ca' + actionNum
    const nameField = 'ca_name' + actionNum
    const typeField = 'ca_type' + actionNum

    console.log('actionNum = ', actionNum, ' / typeField = ', typeField, ' / combatant[typeField] = ', combatant[typeField])

    if (
      combatant[typeField] == 'action' &&
      combatant[nameField] != 'pending' &&
      combatant[nameField] != 'blank'
    ) {
      console.log('got image')
      return {
        image: combatant[imageField],
        name: combatant[nameField],
        action: getAction(combatant[nameField]) ?? null,
      }
    }
  }

  console.log('gonna be blank image')
  return {
    image: blankAction,
    name: 'blank',
    action: null,
  }
}
